<template>
  <div class="col">
    <p>이 개인정보 보호정책의 목적은 사용자("사용자")에게 개인 데이터 처리 목적, 범위, 처리 시간 및 tobook.link 웹사이트 및 모바일 애플리케이션("tobook.link", "앱") 및 예약 서비스를 사용할 때 개인 권리에 대한 정보를 제공하는 것입니다.</p>
    <p>우리는 귀하의 개인 정보와 개인 데이터 보호를 중요하게 생각하며 적용 가능한 법률 — 2016년 4월 27일 유럽 의회와 이사회의 개인 데이터 처리 및 그러한 데이터의 자유로운 이동에 관한 자연인의 보호에 대한 규정(일반 데이터 보호 규정) ("규정") 및 개인 정보 및 데이터 처리 문제를 규제하는 기타 법적 규정에 따라 귀하의 개인 데이터를 처리합니다.</p>
    <p>tobook.link는 서비스 또는 적용 가능한 법률 및 규정의 변경으로 인해 언제든지 이 정책을 검토하고 변경할 권리를 보유합니다. 우리는 중요한 변경 사항을 통지할 것이며, 귀하는 정기적으로 이 정책을 검토할 책임이 있습니다.</p>
    <h6 class="mt-5 mb-3">
      컨트롤러 및 연락처 정보
    </h6>
    <p>개인 데이터의 컨트롤러는 tobook.link s.r.o. (등록 번호 19608217), 법적 주소: Pavla Beneše 750/8, Praha 19900입니다. 귀하는 언제든지 귀하의 개인 데이터와 관련된 질문이나 요청을 위해 저희에게 연락할 수 있습니다.</p>
    <h6 class="mt-5 mb-3">
      개인 데이터 카테고리
    </h6>
    <p>식별 데이터 — 이름, 성, 사진(선택 사항). 연락처 정보 — 전화번호, 이메일 주소. 우리는 GDPR에 정의된 특별 카테고리의 개인 데이터를 수집하지 않습니다.</p>
    <h6 class="mt-5 mb-3">
      개인 데이터 처리 목적
    </h6>
    <ul>
      <h6 class="mt-4">
        <li>기업가 및 회사를 위해:</li>
      </h6>
      <p>1. tobook.link 애플리케이션 등록(프로필 생성).</p>
      <p>2. tobook.link 애플리케이션 사용에 대한 익명 통계 준비.</p>
      <p>3. 상업 메시지 발송.</p>
      <p>4. 온라인 예약 집계기에 회사 데이터 배치. tobook.link 서비스를 사용함으로써 귀하는 귀하의 회사 데이터를 tobook.link 소유의 온라인 예약 집계기에 배치하는 것에 동의합니다. 이는 우리가 귀하가 제공한 데이터를 귀하의 서비스 온라인 예약 및 서비스 품질 개선을 위해 사용할 수 있음을 의미합니다.</p>
      <h6 class="mt-4">
        <li>고객(예약 약속)을 위해:</li>
      </h6>
      <p>1. 예약. 귀하의 개인 데이터는 예약 세부 사항과 함께 서비스 제공업체의 계정에 저장되어 예약 이력을 보고 분석하며, 규제 요구 사항 및 거기에서 비롯된 의무에 따른 목적을 위해 사용됩니다.</p>
      <p>2. 상업 메시지 발송.</p>
    </ul>
    <h6 class="mt-5 mb-3">
      로그 항목
    </h6>
    <p>귀하의 tobook.link 앱 사용 중 오류가 발생할 때마다 우리는 제3자 솔루션의 도움으로 귀하의 전화로부터 데이터 및 정보 — 로그 항목 — 을 수집합니다. 이 로그 항목에는 다음 정보가 포함될 수 있습니다: 장치의 IP 주소, 장치 이름, 운영 체제 버전, 서비스 사용 시 애플리케이션 구성, 서비스 사용 날짜 및 시간 및 기타 통계.</p>
    <p>우리는 이 정보를 처리 및 수집하여 tobook.link 앱의 작동, 효율성 및 사용자 경험을 개선하기 위해 사용합니다. 이 데이터는 우리 앱을 개선하고 더 나은 서비스를 제공하기 위한 우리의 정당한 이익에 기반하여 처리됩니다.</p>
    <h6 class="mt-5 mb-3">
      결제 처리
    </h6>
    <p>Tobook.link에서 제3자 제공업체의 서비스에 대해 지불할 때, 결제는 우리의 결제 게이트웨이 제공업체인 Stripe를 통해 처리됩니다. 귀하는 Stripe에 직접 신용카드 또는 직불카드 정보를 제공하게 되며, Stripe는 결제 세부 정보를 암호화하고 결제를 승인하기 위해 안전한 서버를 운영합니다. Tobook.link는 카드 정보를 수집하지 않습니다.</p>
    <p>귀하가 Stripe에 제공하는 정보는 우리의 통제 범위를 벗어나며 Stripe의 자체 <b-link href="https://stripe.com/en-cz/privacy" target="_blank">개인정보 보호정책</b-link>에 따릅니다.</p>
    <p>개인 기업가 및 회사를 위한 결제 처리 서비스는 Stripe에 의해 제공되며, Stripe 서비스 이용 약관(Stripe 서비스 계약)을 포함한 <b-link href="https://stripe.com/en-gb/legal/connect-account" target="_blank">Stripe Connected 계정 계약</b-link>에 따라 제공됩니다. 귀하가 계약에 동의하거나 tobook.link에서 개인 기업가 또는 회사로 계속 운영함으로써 귀하는 Stripe가 가끔 수정할 수 있는 Stripe 서비스 계약에 구속되는 것에 동의합니다. Stripe를 통해 결제 처리 서비스를 가능하게 하는 조건으로, 귀하는 귀하와 귀하의 사업에 대한 정확하고 완전한 정보를 tobook.link에 제공하고 귀하가 사용하는 결제 처리 서비스와 관련된 거래 정보를 공유하도록 tobook.link에 권한을 부여하는 데 동의합니다.</p>
    <h6 class="mt-5 mb-3">
      개인 데이터의 보안
    </h6>
    <p>개인 데이터 처리 시, 우리는 고급 기술 솔루션을 사용하고 안전한 서비스 제공업체와 협력하며 개인 정보 위험을 평가하고 사용 가능한 조직 및 재정 자원을 사용합니다. 우리는 우리에게 위임된 데이터에 대한 책임을 지며, 우리 서비스 제공에 필요하지 않은 데이터는 수집하거나 처리하지 않습니다.</p>
    <p>우리의 직원들과 비즈니스 파트너들은 위에서 언급한 목적을 위해서만 데이터를 사용하며 엄격한 계약상의 기밀 유지 의무를 준수합니다.</p>
    <p>개인 데이터는 EU 및 EEA 영토에서 데이터 처리를 제공하는 안전한 클라우드 컴퓨팅 및 서버 솔루션에 저장됩니다. 이러한 서비스의 제공업체를 변경할 때, 우리는 항상 규정의 요구 사항을 준수하는 신뢰할 수 있는 파트너와만 협력할 것을 보장합니다. 그러나 우리는 전자 저장 방법이 절대적으로 안전하고 신뢰할 수 있으며 완벽하지 않다는 점을 유의해야 합니다. 우리는 그것의 절대적인 보안을 보장할 수 없습니다.</p>
    <h6 class="mt-5 mb-3">
      개인 데이터 처리의 법적 근거
    </h6>
    <p>우리는 tobook.link 앱 사용자의 개인 데이터를 다음과 같은 데이터 처리의 법적 근거에만 기초하여 처리합니다:</p>
    <ul>
      <li>하나 이상의 구체적인 목적을 위해 귀하의 개인 데이터 처리에 대한 귀하의 동의.</li>
      <li>귀하와의 계약 체결 또는 이행을 위해 필요하거나, 계약 체결 전 귀하의 요청에 따른 조치를 취하기 위해 필요합니다.</li>
      <li>법적 의무를 이행하기 위해 필요합니다.</li>
      <li>귀하 또는 다른 사람의 중대한 이익을 보호하기 위해 필요합니다.</li>
      <li>공공 이익을 위해 수행되는 과제의 수행을 위해 필요합니다.</li>
      <li>우리 또는 제3자의 정당한 이익을 위해 필요하며, 이러한 이익이 귀하의 이익이나 기본적 권리 및 자유에 의해 침해되지 않는 경우.</li>
    </ul>
    <h6 class="mt-5 mb-3">
      개인 데이터 보존 기간
    </h6>
    <p>우리는 개인 데이터를 다음 기간 동안 저장합니다:</p>
    <ul>
      <li>
        데이터가 수집된 목적에 필요한 경우.
      </li>
      <li>
        데이터 주체와 우리가 법률 및 규정에서 명시한 절차에 따라 우리의 정당한 이익을 구현할 수 있는 경우(이의 제기 또는 소송 제기).
      </li>
      <li>
        개인 데이터를 보관해야 할 법적 의무가 있는 경우.
      </li>
      <li>
        관련 개인 데이터 처리에 대한 데이터 주체의 동의가 유효한 경우, 다른 법적 근거가 없는 한.
      </li>
    </ul>
    <p>이러한 기간이 지난 후, 귀하의 개인 데이터는 영구적으로 삭제되거나 익명화되어 더 이상 귀하에게 연결되지 않습니다.</p>
    <h6 class="mt-5 mb-3">
      데이터 제3자 이전
    </h6>
    <p>tobook.link 앱의 운영을 보장하기 위해 우리는 귀하의 개인 데이터를 처리할 수 있는 제3자 서비스("처리자")를 사용합니다:</p>
    <!-- link -->
    <table-partners />
    <cite>*이 제3자의 개인정보 보호정책과 그들이 귀하의 데이터를 어떻게 처리하는지 읽어보십시오.</cite>
    <p class="mt-1">
      우리는 다음을 제외하고 귀하의 개인 데이터를 다른 제3자에게 공개하지 않습니다:
    </p>
    <ul>
      <li>귀하의 명시적이고 명확한 동의에 따라;</li>
      <li>규정된 절차 및 범위 내에서 규정된 법령에 따라 지정된 사람에게;</li>
      <li>적법한 이익 보호를 위해 규정된 경우, 예를 들어 잠재적 사기, 우리의 약관 또는 정책 위반 또는 기타 불법 활동의 탐지, 예방 또는 조사, 또는 우리의 권리, 재산 또는 안전 또는 다른 사람의 권리, 재산 또는 안전을 보호하는 경우.</li>
    </ul>
    <h6 class="mt-5 mb-3">
      기타 사이트로의 링크
    </h6>
    <p>tobook.link 앱에는 사용자의 개인 데이터 처리 규칙이 tobook.link에 의해 관리되지 않는 기타 웹사이트 또는 앱에 대한 링크가 포함될 수 있습니다. 따라서 이러한 웹사이트의 기밀성 정책을 읽는 것이 좋습니다. 우리는 제3자 웹사이트 또는 서비스의 콘텐츠 및 개인정보 보호정책에 대한 통제권이 없으며 책임을 지지 않습니다.</p>
    <h6 class="mt-5 mb-3">
      어린이의 개인 정보 보호
    </h6>
    <p>tobook.link 앱에서 제공하는 서비스는 13세 미만의 사람들에게 적용되지 않습니다. 13세 미만의 어린이로부터 개인 데이터를 수집한 것으로 밝혀지면, 우리는 tobook.link 서비스를 중단하고 우리 시스템에서 해당 데이터를 삭제할 것입니다. 만약 귀하가 해당 아동의 부모 또는 보호자이며 귀하의 자녀가 개인 정보를 제공한 것을 알고 있다면, 필요한 조치를 취하기 위해 저희에게 연락해 주십시오.</p>
    <h6 class="mt-5 mb-3">
      상업적 통신
    </h6>
    <p>tobook.link와 사용자 간의 법적 관계를 고려할 때, 그리고 규정에 따라, tobook.link는 그것의 정당한 이익에 기초하여 상업적 통신을 발송할 수 있습니다. 이러한 통신은 사용자가 선택한 예약 및 서비스 유형과 관련된 서비스 및 제안에 대해 발송될 수 있습니다.</p>
    <p>다른 서비스의 상업적 통신은 사용자가 이러한 통신을 받기로 동의한 경우에만 사용자에게 발송됩니다. 귀하는 언제든지 이메일에 있는 구독 해지 링크를 사용하거나 직접 저희에게 연락함으로써 이러한 통신을 받는 것을 거부할 권리가 있습니다.</p>
    <h6
      id="cookies"
      class="mt-5 mb-3"
    >
      "쿠키"
    </h6>
    <p>쿠키는 웹사이트를 탐색하는 동안 브라우저에 의해 컴퓨터 또는 모바일 기기에 저장되는 작은 데이터 조각입니다. 서버가 브라우저로부터 정보를 수집할 수 있도록 하여 웹사이트로 돌아올 때마다 데이터를 다시 입력할 필요가 없게 합니다. 쿠키가 어떻게 작동하는지에 대한 자세한 정보는 웹사이트
      <b-link
        target="_blank"
        href="http://www.cookiecentral.com"
      >www.cookiecentral.com</b-link>을 참조하십시오.</p>
    <p>우리는 어떻게 쿠키를 사용합니까? tobook.link 앱은 서비스 품질을 향상시키고 앱 사용에 대한 익명 통계 수행 및 마케팅 목적으로 얻은 데이터 분석을 위해 쿠키를 사용합니다. 우리는 필수 쿠키, 세션 쿠키 및 분석 쿠키(첫 번째 및 제3자 (파트너) 쿠키)를 사용하여:</p>
    <ul>
      <li>앱의 보안을 보장하고 관리합니다.</li>
      <li>귀하의 앱 사용 언어를 기억합니다.</li>
      <li>쿠키 사용에 대한 귀하의 동의를 기억합니다.</li>
      <li>마케팅 캠페인의 효과를 돕습니다.</li>
      <li>사용자의 앱 사용에 대한 정보를 수집하여 앱이 사용자의 요구를 얼마나 잘 충족하는지 측정하고 필요한 개선을 할 수 있도록 합니다.</li>
      <li>일부 쿠키는 우리의 필요를 위해 특정 기능을 수행하는 서비스 제공업체(예: Google)에 의해 귀하의 컴퓨터에 배치될 수 있습니다.</li>
    </ul>
    <p>귀하의 동의가 필요하지 않은 tobook.link 앱에서 사용하는 쿠키도 있습니다:</p>
    <ul>
      <li>세션 동안에만 남아 있는 귀하가 입력한 정보의 쿠키</li>
      <li>세션 동안에만 남아 있는 인증 쿠키.</li>
    </ul>
    <h6 class="mt-5 mb-3">
      개인 데이터 및 그 전송
    </h6>
    <p>쿠키와 관련된 정보는 귀하를 개인적으로 식별하는 데 사용되지 않습니다. 그러나 우리는 이 정보를 이 정책에서 설명한 목적을 위해 우리가 보유하고 있는 귀하에 대한 다른 정보와 연결할 수 있습니다.</p>
    <p>우리는 우리에게 서비스를 제공하는 제3자, 예를 들어 tobook.link 앱 분석 또는 고객 서비스와 귀하의 데이터를 공유할 수 있습니다. 이러한 사람들은 필요한 범위 내에서만 귀하의 데이터를 사용할 수 있도록 허가받습니다.</p>
    <p>우리는 이 개인정보 보호정책에서 설명한대로만 귀하의 데이터를 제3자에게 제공합니다. 우리는 어떤 방식으로든 귀하의 데이터를 제3자에게 판매하지 않습니다.</p>
    <h6 class="mt-5 mb-3">
      귀하의 권리
    </h6>
    <p>귀하는 언제든지 귀하의 개인 데이터에 대한 정보를 요청할 권리가 있으며, 저장된 정보의 정확성을 확인하고/또는 이 정보를 변경하거나 업데이트할 수 있습니다. 또한 데이터가 더 이상 처리에 필요하지 않은 경우 귀하의 개인 데이터의 완전한 삭제를 요청할 수 있습니다, 법률에 의해 보관해야 하는 경우는 제외하고.</p>
    <p>우리는 요청을 받은 후 1개월 이내에 귀하에게 적절한 개인 데이터에 대한 접근을 제공하기 위해 상업적으로 합리적인 노력을 기울일 것입니다, 예외적인 상황이 발생하는 경우 우리는 귀하에게 알릴 것입니다.</p>
    <p>귀하의 개인 정보 및 보안을 보호하기 위해, 정보에 대한 접근을 제공하기 전에 귀하의 신원을 확인하기 위한 적절한 조치를 취할 것입니다.</p>
    <h6 class="mt-5 mb-3">
      불만
    </h6>
    <p>모든 불만 및 요청은 다음으로 보낼 수 있습니다: <b-link
      :to="{name: 'partners'}"
    >tobook.link</b-link></p>
    <p>우리가 귀하의 법적 권리를 침해하고 있다고 생각하는 경우, 귀하는 Česká obchodní inspekce, Štěpánská 44, 110 00 Praha 1에 데이터 국가 감독관에게 불만을 제기할 수 있습니다</p>
  </div>
</template>

<script>
import {
  BLink,
} from 'bootstrap-vue'
import TablePartners from '@/components/policy/TablePartners.vue'

export default {
  name: 'KoPrivacyPolicy',
  components: {
    TablePartners,
    BLink,
  },
}
</script>

<style scoped>

</style>
